import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Cadastro.css";
const API_URL = process.env.REACT_APP_API_URL;

const Cadastro = () => {
  const navigate = useNavigate();

  const [nome, setNome] = useState("");
  const [sobrenome, setSobrenome] = useState("");
  const [cpf, setCpf] = useState("");
  const [celular, setCelular] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [msg, setMsg] = useState("");
  const [sucesso, setSucesso] = useState(false); // <-- Novo estado

  const validarEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const aplicarMascaraCpf = (valor) => {
    valor = valor.replace(/\D/g, "");
    valor = valor.replace(/(\d{3})(\d)/, "$1.$2");
    valor = valor.replace(/(\d{3})(\d)/, "$1.$2");
    valor = valor.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    return valor;
  };

  const aplicarMascaraCelular = (valor) => {
    valor = valor.replace(/\D/g, "");
    valor = valor.replace(/^(\d{2})(\d)/g, "($1) $2");
    valor = valor.replace(/(\d{5})(\d)/, "$1-$2");
    return valor;
  };

  const validarCpf = (cpf) => {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    let soma = 0;
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
    let resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;
    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    return resto === parseInt(cpf.charAt(10));
  };

  const handleCadastro = async () => {
    if (!nome || !sobrenome || !email || !senha) {
      setMsg("Preencha todos os campos obrigatórios.");
      setSucesso(false);
      return;
    }

    if (!validarEmail(email)) {
      setMsg("E-mail inválido.");
      setSucesso(false);
      return;
    }

    if (cpf && !validarCpf(cpf)) {
      setMsg("CPF inválido.");
      setSucesso(false);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          nome,
          sobrenome,
          cpf,
          celular,
          email,
          senha,
          codigoPagseguro: null,
        }),
      });

      if (response.ok) {
        setMsg("Cadastro feito com sucesso!");
        setSucesso(true);
        setTimeout(() => navigate("/login"), 2000); // Agora espera 2 segundos
      } else {
        setMsg("Erro ao cadastrar. Tente novamente.");
        setSucesso(false);
      }
    } catch (error) {
      console.error("Erro no cadastro:", error);
      setMsg("Erro de conexão. Verifique sua rede.");
      setSucesso(false);
    }
  };

  const handleCpfChange = (e) => {
    setCpf(aplicarMascaraCpf(e.target.value));
  };

  const handleCelularChange = (e) => {
    setCelular(aplicarMascaraCelular(e.target.value));
  };

  return (
    <div className="cadastro-container">
      <div className="cadastro-box">
        <h2>Cadastro</h2>
        <input
          placeholder="Nome *"
          value={nome}
          onChange={(e) => setNome(e.target.value)}
        />
        <input
          placeholder="Sobrenome *"
          value={sobrenome}
          onChange={(e) => setSobrenome(e.target.value)}
        />
        <input
          placeholder="CPF*"
          value={cpf}
          onChange={handleCpfChange}
          maxLength="14"
        />
        <input
          placeholder="Celular*"
          value={celular}
          onChange={handleCelularChange}
          maxLength="15"
        />
        <input
          placeholder="Email *"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Senha *"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />
        <button onClick={handleCadastro}>Cadastrar</button>

        {msg && (
          <p className="cadastro-msg" style={{ color: sucesso ? "green" : "red" }}>
            {msg}
          </p>
        )}

        <p>
          Já tem uma conta? <Link to="/login">Faça login</Link>
        </p>
      </div>
    </div>
  );
};

export default Cadastro;
